<div class="spinner-wrapper">
  <mat-spinner></mat-spinner>
</div>
